/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */

export type FeeType = typeof FeeType[keyof typeof FeeType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeeType = {
  PERCENTAGE: 'PERCENTAGE',
  FIXED_AMOUNT: 'FIXED_AMOUNT',
} as const;
